import React from 'react'
import gql from 'graphql-tag'
import { Query } from 'react-apollo'
import { AttackEvent, attackEventFragment } from './shared'

export const attackEventQuery = gql`
  query GetAttackEvent($organizationID: ID!, $attackEventID: ID!) {
    attackEvent(
      organizationID: $organizationID
      attackEventID: $attackEventID
    ) {
      ...AttackEvent
    }
  }

  ${attackEventFragment}
`

interface AttackEventQueryProps {
  readonly organizationID: string
  readonly rowDataID: string
  readonly children: (rowData: AttackEvent) => React.ReactNode
}

export function GridRowQuery({
  organizationID,
  rowDataID,
  children
}: AttackEventQueryProps) {
  return (
    <Query
      query={attackEventQuery}
      fetchPolicy="cache-only"
      variables={{
        organizationID,
        attackEventID: rowDataID
      }}
      errorPolicy="all"
    >
      {(result) => {
        const { data, error } = result
        if (error) {
          throw new Error(error.message)
        }
        const { attackEvent } = data
        return children(attackEvent)
      }}
    </Query>
  )
}
